import React, { useState } from 'react';
import {
  ImageBackground,
  ImageSourcePropType,
  StyleSheet,
  View,
} from 'react-native';
import IconAvatar from 'shared/components/vxl/avatar/IconAvatar/IconAvatar';
import theme from 'shared/styles/theme';

interface OfferDetailsHeaderProps {
  heroImage: string | undefined;
  logoImage: string | undefined;
  defaultHeroImage: ImageSourcePropType;
}

const OfferDetailsHeader = ({
  heroImage,
  logoImage,
  defaultHeroImage,
}: OfferDetailsHeaderProps) => {
  const [showHeroImage, setShowHeroImage] = useState<boolean>(true);

  return (
    <ImageBackground
      testID="image-background"
      style={styles.heroImageLogo}
      source={
        showHeroImage
          ? {
              uri: heroImage,
            }
          : defaultHeroImage
      }
      role="img"
      accessible
      accessibilityLabel="offer-hero-image"
      onError={() => setShowHeroImage(false)}
    >
      <View style={styles.logo} testID="icon-avatar">
        <IconAvatar
          variant="LG"
          backgroundColor={theme.color.background.primary}
          defaultPlaceholderIcon="STORE"
          imageSource={{ uri: logoImage }}
          iconAccessibilityLabel="offer-logo-image"
        />
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  heroImageLogo: {
    height: 210,
    width: '100%',
  },
  logo: {
    height: 70,
    left: '43%',
    position: 'absolute',
    top: '85%',
    width: 70,
  },
});

export default OfferDetailsHeader;
